





















































import { sportUrlName as getSportUrlName } from '@modules/eventGrid/nameExtractors';
import { RouteName } from '@src/app/router/constants/RouteName';
import { MaintenanceStore } from '@store/modules/data/maintenance/maintenanceIndex';
import {
    SdsIcon,
    SdsIllustration,
} from '@superbet-group/web.lib.ui-components';
import { slugify } from '@superbet-group/web.lib.utilities';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    PropType,
    ref,
    watch,
} from '@vue/composition-api';
import BetBuilderBanner from '../../banners/BetBuilderBanner.vue';
import StackedFlags from './StackedFlags.vue';
import { useMEBBAnalytics } from '../composables/useMEBBAnalytics';
import { useMEBBPreview } from '../composables/useMEBBPreview';
import OfferEvent from '@core/models/offer/OfferEvent';
import { getTopEventsPreview } from '@core/services/offer/CmsOfferService';
import { TopEventType } from '@core/services/offer/enums';
import { mebbMaintenanceConfig } from '../constants';
import { MultiEventBetBuilderBannerLocation } from '../enums/MultiEventBetBuilderBannerLocation';

const minimumNumberOfEvents = 5;

export default defineComponent({
    name: 'MEBBBanner',
    props: {
        sportId: {
            type: Number,
            required: false,
            default: null,
        },
        location: {
            type: String as PropType<MultiEventBetBuilderBannerLocation>,
            required: true,
        },
    },
    setup(props) {
        const maintenanceStore = useVuexStore<MaintenanceStore>('data/maintenance');
        const isInMaintenance = maintenanceStore.getter('isInMaintenance');

        const { bannerDisplayed, bannerClicked } = useMEBBAnalytics();
        const topBetBuilderEvents = ref<Pick<OfferEvent, 'categoryId' | 'tournamentId'>[]>([]);
        const { flags, numberOfCompetitions } = useMEBBPreview(topBetBuilderEvents);

        const isVisible = computed(() => topBetBuilderEvents.value.length >= minimumNumberOfEvents);

        const { router } = useVueRouter();

        const route = computed(() => {
            const params: Record<string, string> = {};

            if (props.sportId) {
                params.sportSlug = slugify(getSportUrlName(props.sportId)).toLowerCase();
            }

            const { route } = router.value.resolve({
                name: RouteName.Sport.MultiEventBetBuilder,
                params,
            });

            return route;
        });

        onMounted(async () => {
            const { data } = await getTopEventsPreview({ eventType: TopEventType.BetBuilder });

            topBetBuilderEvents.value = data;
        });

        const unwatchIsVisible = watch(isVisible, (newValue) => {
            if (newValue) {
                bannerDisplayed({
                    location: props.location,
                    eventsCount: topBetBuilderEvents.value.length,
                    competitionsCount: numberOfCompetitions.value,
                });
                unwatchIsVisible?.();
            }
        }, { immediate: true });

        onUnmounted(() => {
            unwatchIsVisible?.();
        });

        const handleBannerClick = () => {
            bannerClicked({
                location: props.location,
                eventsCount: topBetBuilderEvents.value.length,
                competitionsCount: numberOfCompetitions.value,
            });
        };

        return {
            flags,
            isInMaintenance,
            isVisible,
            maintenanceApplicableTypes: mebbMaintenanceConfig.applicableTypes,
            numberOfCompetitions,
            topBetBuilderEvents,
            route,
            handleBannerClick,
        };
    },
    components: {
        BetBuilderBanner,
        StackedFlags,
        SdsIcon,
        SdsIllustration,
    },
});
